import { EntityCatalog } from 'src/app/shared/components/entity-catalog/entity-catalog.types';

/**
 * Regulatory floors — step 2 of onboarding a country.
 *
 * A lock is the difference between a rule pack an operator may weaken freely and one a
 * regulator's minimum actually constrains. Locks are deactivated rather than deleted, because
 * "who relaxed this, and when" is the question asked after an incident.
 */
export const COMPLIANCE_LOCK_CATALOG: EntityCatalog = {
  title: 'Compliance Locks',
  singular: 'Compliance Lock',
  idKey: 'id',
  statusFieldKey: 'is_active',
  // Locks are read country by country — "what does the UAE floor at" is the actual question.
  facetFieldKey: 'country_code',
  facetAllLabel: 'All countries',
  fields: [
    {
      key: 'country_code',
      label: 'Country pack',
      kind: 'enum',
      inList: true,
      required: true,
      options: [],
      // The API upserts on (country_code, parameter_key). Editing either on an existing lock
      // would create a second lock and leave the original floor in force.
      immutable: true,
    },
    {
      key: 'parameter_key',
      label: 'Parameter',
      kind: 'text',
      inList: true,
      required: true,
      immutable: true,
      placeholder: 'biometric.face_match_threshold',
      hint: 'Dotted path into the rule payload. A key with no dot would never match anything.',
    },
    {
      key: 'minimum_value',
      label: 'Minimum value',
      kind: 'text',
      inList: true,
      required: true,
      hint: 'A number (90) or true/false. Stored as typed JSON, not text.',
    },
    {
      key: 'regulation',
      label: 'Regulation',
      kind: 'text',
      inList: true,
      required: true,
      placeholder: 'CBUAE Standards for Digital KYC',
      hint: 'Required — a floor with no cited authority cannot be justified to an auditor.',
    },
    { key: 'regulation_article', label: 'Article', kind: 'text' },
    { key: 'description', label: 'Description', kind: 'text' },
    { key: 'is_active', label: 'Active', kind: 'boolean', inList: true },
  ],
};
